import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'

export default function Menu() {
	const location = useLocation()
	const [currentMenuItem, setCurrentMenuItem] = useState("")

	// Scroll to the top on route change
	useEffect(() => {
		setCurrentMenuItem(location.pathname)
		window.scrollTo(0, 0) // This will scroll the page to the top whenever the route changes
	}, [location.pathname])

	const checkCurrentMenuItem = (path) => currentMenuItem === path ? "current-menu-item" : ""
	const checkParentActive = (paths) => paths.some(path => currentMenuItem.startsWith(path)) ? "current-menu-item" : ""

	return (
		<>
			<ul className="menu">
				{/*<li className={`${checkParentActive(["/homev2", "/homev3"])}`}>*/}
				{/*	<Link to="/#">Home page</Link>*/}

				{/*</li>*/}
				{/*<li className={`${checkParentActive(["/event", "/event-details"])}`}>*/}
				{/*	<Link to="/#">Our Events</Link>*/}
				{/*	<ul className="submenu">*/}
				{/*		<li className={`item ${checkCurrentMenuItem("/event")}`}><Link to="/event">Events</Link></li>*/}
				{/*		<li className={`item ${checkCurrentMenuItem("/event-details")}`}><Link to="/event-details">Events Details</Link></li>*/}
				{/*	</ul>/!* /.submenu *!/*/}
				{/*</li>*/}

				<li className={`item ${location.pathname === "/contact" ? "current-menu-item" : ""}`}><Link to="/contact"> Inscription</Link></li>
			</ul>{/* /.menu */}
		</>
	)
}
